import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStopNoteCompareItem extends Layout {
    sourceEdiCompareItem: DataSource;
    tableCompareItems: Table;
}
